import { AppStateStore } from './AppStateStore';
import { ConfigStore } from './ConfigStore';
import { PortHealthStore } from './PortHealthStore';
import { PortStore } from './PortStore';
import { ThemeStore } from './ThemeStore';
import { VesselScenarioStore } from './VesselScenarioStore';
import { YardSafeStore } from './YardSafeStore';

export class RootStore {
  // Currently used by MA
  vesselScenarioStore: VesselScenarioStore;

  configStore: ConfigStore;

  portStore: PortStore;

  appStateStore: AppStateStore;

  yardSafeStore: YardSafeStore;

  themeStore: ThemeStore;

  portHealthStore: PortHealthStore;

  constructor() {
    this.vesselScenarioStore = new VesselScenarioStore(this);
    this.configStore = new ConfigStore(this);
    this.portStore = new PortStore(this);
    this.yardSafeStore = new YardSafeStore(this);
    this.appStateStore = new AppStateStore(this);
    this.themeStore = new ThemeStore(this);
    this.portHealthStore = new PortHealthStore(this);
  }
}
